<template>
  <div class="compound public-content">
    <div class="breadcrumb">机器码管理</div>
    <div style="overflow:hidden" class="add-category">
      <div class="keywords">
        <span style="margin:0 5px 0 0 ">机器码名称: </span>
        <el-input v-model="machineCodeName" maxlength="20" placeholder="请输入机器码名称"></el-input>
      </div>
      <div>
        <el-button class="search-ok" style="margin:10px 50px 10px 0;" @click="queryInfo.pageNum = 1, onSubmit()" round>查询</el-button>
        <el-button @click="newBuilt()" type="primary" style="margin:10px 50px 10px 0;float:right" round>新建机器码 </el-button>
      </div>
    </div>
    <div class="right-main">
      <div class="data-list">
        <el-table :data="tableData" border>
          <el-table-column label="机器码名称" prop="machineCodeName"></el-table-column>
          <el-table-column label="机器码编号" prop="machineCodeNumber"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="color-blue" @click="checkEdit('check', scope.row)">查看<br></span>
              <span class="color-blue" @click="checkEdit('edit', scope.row)">编辑<br></span>
              <span class="color-blue" @click="deleteId = scope.row.id, deleteDialog = true">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    <!-- 删除确认 -->
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="deleteDialog" width="30%">
      <span>确认删除该机器码？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deletePage(deleteId)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index'
import { machineCodeList, machineCodeDelete } from '@/api/pms'
export default {
  name: 'compound',
  components: {
    VPagination
  },
  data () {
    return {
      deleteDialog: false,
      deleteId: '',
      queryInfo: {
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      tableData: [],
      machineCodeName: ''
    }
  },
  created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.machineCodeName = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
    }
    this.onSubmit()
  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    checkEdit (type, row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.machineCodeName))
      if (type === 'check') this.$router.push({ path: '/MachineCodeAdmin', query: { type: 'check', id: row.id } })
      if (type === 'edit') this.$router.push({ path: '/MachineCodeAdmin', query: { type: 'edit', id: row.id } })
    },
    newBuilt () {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.machineCodeName))
      this.$router.push({ path: '/MachineCodeAdmin', query: { type: 'add' } })
    },
    deletePage (id) {
      machineCodeDelete(id).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.onSubmit()
          this.deleteDialog = false
        }
      })
    },
    onSubmit () {
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.machineCodeName))
      }
      let obj = {
        machineCodeName: this.machineCodeName
      }
      machineCodeList({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, machineCodeName: obj }).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data.records
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
<style scoped lang="less">
.compound {
  .add-category {
    justify-content: space-between;
  }

  .keywords {
    display: flex;
    justify-content: space-around;
    // width: 750px;
    align-items: center;

    .el-input {
      width: 180px;
    }
  }
}

.keywords {
  display: flex;
  justify-content: space-around;
  // width: 750px;
  align-items: center;

  .el-input {
    width: 180px;
  }
}
</style>
